import type {Component} from 'typings/portaro.fe.types';
import type {MessageSendingPost} from 'typings/portaro.be.types';
import KpMessageSendingComponent from '../kp-message-sending/kp-message-sending.component';
import type {ISCEService} from 'angular';

export class KpMessageSendingPostComponentController implements KpMessageSendingPostComponentBindings {
    public messageSending: MessageSendingPost;

    /*@ngInject*/
    constructor(private $sce: ISCEService) {
    }
}

/**
 * @ngdoc component
 * @name kpMessageSendingPost
 * @module uc.message
 *
 * @param {MessageSending} messageSending
 *
 * @description
 *
 */
export default class KpMessageSendingPostComponent implements Component<KpMessageSendingPostComponentBindings> {
    public static componentName = 'kpMessageSendingPost';

    public require = {
        messageSendingController: `^${KpMessageSendingComponent.componentName}`
    };

    public templateUrl = require('./kp-message-sending-post.tpl.ftl');

    public bindings = {
        messageSending: '<'
    } as const;

    public controller = KpMessageSendingPostComponentController;
}

interface KpMessageSendingPostComponentBindings {
    messageSending: MessageSendingPost;
}
